import { startOfWeek, endOfWeek, subWeeks } from 'date-fns';

/**
 * Get the start and end date of the week (Monday - Sunday) in local time.
 * @param {number} weeksAgo Number of weeks in the past (0 = current week).
 * @returns { startDate: Date, endDate: Date }
 */
export const getWeekRangeInLocalTime = (
	weeksAgo: number = 0,
): { startDate: Date; endDate: Date } => {
	const now = new Date();
	const referenceDate = subWeeks(now, weeksAgo); // Shift weeks back
	const startDate = startOfWeek(referenceDate, { weekStartsOn: 1 }); // Monday start
	const endDate = endOfWeek(referenceDate, { weekStartsOn: 1 }); // Sunday end

	return { startDate, endDate };
};
